module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "body_content-a",
    attrs: {
      "id": "calibre_toc_1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_008#_idTextAnchor000"
    }
  }, [_vm._v("Introduction")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_011#_idTextAnchor001"
    }
  }, [_vm._v("Shopping Tips")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_019#_idTextAnchor002"
    }
  }, [_vm._v("Pantry Staples")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_024#_idTextAnchor003"
    }
  }, [_vm._v("Baking Pantry Essentials")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_025#_idTextAnchor004"
    }
  }, [_vm._v("Store-Bought Flavor Bombs")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_028#_idTextAnchor005"
    }
  }, [_vm._v("Thrive Market")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_030#_idTextAnchor006"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Breakfast All Day")])]), _c('span', {
    staticClass: "charoverride4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_061#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Carnivore Style")])]), _c('span', {
    staticClass: "charoverride4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_088#_idTextAnchor008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Comfort Food")])]), _c('span', {
    staticClass: "charoverride4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_126#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Dessi’s Paleo Sweets")])]), _c('span', {
    staticClass: "charoverride4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_184#_idTextAnchor010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Happy Hour")])]), _c('span', {
    staticClass: "charoverride4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_228#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("Under the Sea-Food")])]), _c('span', {
    staticClass: "charoverride4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_247#_idTextAnchor012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("It’s all About That Broth")])]), _c('span', {
    staticClass: "charoverride4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_261#_idTextAnchor013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bobby Approved App")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_262#_idTextAnchor014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bolditalics"
  }, [_vm._v("Keto Meal Prep")]), _vm._v(" by FlavCity")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_265#_idTextAnchor015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank You")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_267#_idTextAnchor016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allergen Index")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_271#_idTextb123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")]), _c('a', {
    attrs: {
      "id": "_idTexta123"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_12"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e7cb553","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_006.vue
// module id = 75
// module chunks = 0